import { render, staticRenderFns } from "./HistoryOrderModal.vue?vue&type=template&id=0fc9ecb8&"
import script from "./HistoryOrderModal.vue?vue&type=script&lang=js&"
export * from "./HistoryOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports